<script lang="ts">
  import type {DisplayBanner} from "$lib/serv/banners";
  import type {RestaurantDynamic, RestaurantSemiStatic} from "$lib/def/landing";
	import {Vertical} from "$lib/def/verticals";
  import {get$} from "$lib/serv/core/auth";
  import {KEY_ITEM_MERCH} from "$lib/serv/food-landing";
  import {query} from "$lib/util/url";
  import {firstValueFrom} from "rxjs";
	import {restaurants$, shops$ } from "$lib/ui/home/FoodLanding.svelte";
	import {navPDP} from "$lib/ui/home/food/ItemMerchGrid.svelte";
	import type {ItemSwimlane} from "$lib/ui/home/food/ItemMerchSwimlane.svelte";
  import LazyImage from "$lib/ui/shared/LazyImage.svelte";

  type Props = {
    banner: DisplayBanner,
    endpoint: string,
    searchParams: Record<string, string>,
    id: string,
    index: number,
  }
  const {banner, endpoint, searchParams, id, index}: Props = $props();

  async function onMerchBannerClick(banner: DisplayBanner, params: Record<string, string>) {
    const urlParams = new URLSearchParams(params);
    // restaurant/grid banner
    if (banner.sub_type === "restaurant") {
      query(urlParams).set(KEY_ITEM_MERCH, banner.admin_campaign_uuid).go({noScroll: true});
      return;
    }

    // single/pdp banner
    const swimlane = firstValueFrom(get$<ItemSwimlane>(`api:/${endpoint}`));
    const [rests, shops, lane] = await Promise.all([firstValueFrom(restaurants$), firstValueFrom(shops$), swimlane]);

    const item = lane.swimlane.swimlane_data[0];
    const merchant = params.vertical === Vertical.Store ? shops : rests;
    item.restaurant = {
      dynamic: merchant.dynamic.get(item.restaurant_id) as RestaurantDynamic,
      semi_static: merchant.semi_static.get(item.restaurant_id) as RestaurantSemiStatic,
    };

    navPDP(item, urlParams);
  }
</script>

<button onclick={() => onMerchBannerClick(banner, searchParams)}
	class="item"
	class:cropped={!banner.image_only && banner.cropped}
	class:portrait={!banner.image_only && banner.portrait}
	class:portraitAndCropped={!banner.image_only && banner.portrait && banner.cropped}
	style:background-color={banner.colours?.background}
	style:color={banner.colours?.title}
	style:text-align="left"
	data-testid={`banner_${id}_item_${index}`}
	>
	<!--  -->
	<!-- {banner.type} - C: {banner.cropped} - P: {banner.portrait} - IO: {banner.image_only} -->
	<div class="relative">
		<div class="image">
			<LazyImage image={[banner.image, 500]} alt={banner.title}></LazyImage>
		</div>
		{#if !banner.image_only}
			<div class="text">
				<h4 class="title body-l bold">{banner.title}</h4>
				{#if banner.sub_title}
					<p class="subtitle body-l book" style:color={banner.colours?.subtitle}>{banner.sub_title}</p>
				{/if}
				{#if banner.call_to_action}
					<button style:background-color={banner.colours?.button} style:color={banner.colours?.button_text}>{banner.call_to_action}</button>
				{/if}
			</div>
		{/if}
	</div>
</button>
